import { render, staticRenderFns } from "./user_totals.vue?vue&type=template&id=2a8c860b&scoped=true"
import script from "./user_totals.vue?vue&type=script&lang=js"
export * from "./user_totals.vue?vue&type=script&lang=js"
import style0 from "./user_totals.vue?vue&type=style&index=0&id=2a8c860b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c860b",
  null
  
)

export default component.exports